import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./router/ProtectedRoute";

// Pages
import Login from "./pages/Login";
import SuperadminDashboard from "./pages/SuperadminDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPermissions from "./pages/AdminPermissions";
import UserDashboard from "./pages/UserDashboard";
import GardenInspectorDashboard from "./pages/GardenInspectorDashboard";


const AppRoutes = () => {
  const { user } = useAuth();

  const getDefaultRoute = () => {
    if (!user) return "/login";
    
    const role = user.role?.toLowerCase() || "";
    const roleId = user.role_id;
    
    // Check for Commissioner or Super Admin (role_id 1 or 6)
    if (role === "commissioner" || role === "superadmin" || roleId === 1 || roleId === 6) {
      return "/superadmin";
    }
    
    // All other admin roles go to common admin dashboard
    switch (role) {
      case "superadmin":
      case "commissioner":
        return "/superadmin";
      case "admin":
      case "garden inspector":
      case "divisional officer":
      case "garden superintendent":
      case "superintendent":
      case "additional":
      case "additional commissioner":
        return "/admin";
      default:
        return "/user";
    }
  };

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      <Route
        path="/superadmin/*"
        element={
          <ProtectedRoute requiredPermission="view_permissions">
            <SuperadminDashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/user/*"
        element={
          <ProtectedRoute>
            <UserDashboard />
          </ProtectedRoute>
        }
      />
      
      {/* Redirect old role-specific routes to common admin dashboard */}
      <Route
        path="/garden-assistant/*"
        element={
          <ProtectedRoute>
            <Navigate to="/admin" replace />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/divisional-officer/*"
        element={
          <ProtectedRoute>
            <Navigate to="/admin" replace />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/garden-superintendent/*"
        element={
          <ProtectedRoute>
            <Navigate to="/admin" replace />
          </ProtectedRoute>
        }
      />
      
      <Route path="/" element={<Navigate to={getDefaultRoute()} replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;

